export const visibleCountryCodes = ['us', 'ca', 'au', 'nz', 'uk', 'ie'] as const;

export const countryCodes = ['alpine-web-portal', ...visibleCountryCodes] as const;
